import { useRouter } from "@tanstack/react-router";
import { useEffect } from "react";

export const usePeriodicRefresh = (interval: number) => {
  const router = useRouter();
  useEffect(() => {
    const intervalPtr = setInterval(() => router.invalidate(), interval);
    return () => clearInterval(intervalPtr);
  }, [router]);
};
